var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-wizard"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.categories),function(category){return _c('v-col',{key:category.id,attrs:{"cols":"12","md":"4","lg":"3"}},[_c('app-category-promo',{attrs:{"category":category}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }